import ViewHomes from './ViewHomes';

export default ViewHomes;
